import React, { useEffect, useState } from "react";
import SideBar from "../SideBar";
import Navbar from "../Navbar";
import axiosClient from "../../../axios-client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

function CompanyList() {
  const [loading, setLoading] = useState(true);
  const [companyList, setCompanyList] = useState([]);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [companiesPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null); // Selected company for the modal
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility
  const [deleteConfirmation, setDeleteConfirmation] = useState(false); // To manage the confirmation modal visibility
  const [companyIdToDelete, setCompanyIdToDelete] = useState(null); // Store the company ID to delete
  const [formData, setFormData] = useState({}); // Form data for the edit modal
  const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Edit modal visibility
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    const adminToken = localStorage.getItem("Admin_Token");
    if (!adminToken) {
      navigate("/admin/login");
    }
  }, [navigate]);

  const fetchCompany = async () => {
    try {
      const response = await axiosClient.get("/company/getallcompanies");

      if (response.status === 200) {
        setCompanyList(response.data);
        setLoading(false);
      } else {
        throw new Error("Failed to fetch companies.");
      }
    } catch (err) {
      setError(err.message || "Failed to fetch companies. Please try again.");
      setLoading(false);
    }
  };

  // Fetch all companies on component mount
  useEffect(() => {
    fetchCompany();
  }, []);

  const handleView = (id) => {
    const company = companyList.find((company) => company._id === id);
    setSelectedCompany(company);
    setIsModalOpen(true);
  };

  const handleDeleteClick = (id) => {
    setCompanyIdToDelete(id); // Store the ID of the company to delete
    setDeleteConfirmation(true); // Show the confirmation modal
  };

  const handleUpdate = (id) => {
    console.log("Update button clicked for company ID:", id);
    // Implement update logic here
  };

  const handleDelete = (id) => {
    console.log("Delete button clicked for company ID:", id);
    if (!companyIdToDelete) return;

    try {
      setLoading(true); // Set loading to true before making the API call
      // Simulate the 5-second wait by using setTimeout
      setTimeout(async () => {
        await axiosClient.delete(`/company/delete/${companyIdToDelete}`);
        setLoading(false); // Reset loading state
        setDeleteConfirmation(false); // Close the delete confirmation modal
        setCompanyIdToDelete(null); // Clear the ID of the company to delete

        // Optionally, handle the success case (e.g., update the UI)
        console.log(
          `Company with ID ${companyIdToDelete} deleted successfully.`
        );
      }, 2000); // Wait for 5 seconds before calling the API
    } catch (error) {
      setLoading(false); // Reset loading state in case of error
      console.error("Error deleting company:", error);
      // Optionally, show an error message to the user
    }
  };
  // Cancel deletion and close the confirmation modal
  const handleCancelDelete = () => {
    setDeleteConfirmation(false); // Close the delete confirmation modal
    setCompanyIdToDelete(null); // Clear the selected company ID
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCompany(null);
  };
  // Get current companies to display
  const indexOfLastCompany = currentPage * companiesPerPage;
  const indexOfFirstCompany = indexOfLastCompany - companiesPerPage;
  const currentCompanies = companyList.slice(
    indexOfFirstCompany,
    indexOfLastCompany
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const filteredCompanies = companyList.filter((company) =>
    company.companyName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // edit company
  const handleEditClick = (id) => {
    const company = companyList.find((company) => company._id === id);
    if (company) {
      setFormData(company); // Populate form data
      setSelectedCompany(company);
      setIsEditModalOpen(true);
    }
  };
  // Close the edit modal
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedCompany(null);
    setFormData({});
  };

  // Handle form changes
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle submit for updates
  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await axiosClient.put(
        `/company/editcompany/${selectedCompany._id}`,
        formData
      );
      setLoading(false);
      setIsEditModalOpen(false);
      fetchCompany(); // Refresh company list
    } catch (error) {
      setLoading(false);
      console.error("Error updating company:", error.message);
    }
  };

  // Calculate the range of pagination buttons to display
  const maxButtons = 10;
  const startPage = Math.floor((currentPage - 1) / maxButtons) * maxButtons + 1;
  const endPage = Math.min(
    startPage + maxButtons - 1,
    Math.ceil(filteredCompanies.length / companiesPerPage)
  );

  const handleDeleteAll = async () => {
    try {
      const deleteAll = await axiosClient.delete("/company/deleteall");
      window.location.reload();
    } catch (error) {
      console.error("Error deleting all companies:", error);
    }
  };

  return (
    <>
      <SideBar />
      {/* <Navbar /> */}
      <div
        className="w-3/4 p-8 bg-gray-100 relative right-[-250px]"
        style={{ width: "84%" }}
      >
        <h1 className="text-2xl font-bold mb-4">Company List</h1>
        <div className="mb-4 flex gap-2 justify-end">
          <button
            className="bg-red-500 text-white px-2 py-1 rounded"
            onClick={() => setDeleteModal(true)}
          >
            Delete All Companies
          </button>
          {/* <FontAwesomeIcon
            icon={faSearch}
            className="absolute right-[290px] top-4.5   text-gray-500"
          /> */}
          <input
            type="text"
            placeholder="Search by company name..."
            className="border border-gray-300  rounded px-4 py-2 w-1/4"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-200">
              <thead>
                <tr>
                  <th className="px-4 py-2 border-b text-left">Company Name</th>
                  <th className="px-4 py-2 border-b text-left">Headquarter</th>
                  <th className="px-4 py-2 border-b text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredCompanies
                  .slice(indexOfFirstCompany, indexOfLastCompany)
                  .map((company) => (
                    <tr key={company._id}>
                      <td className="px-4 py-2 border-b">
                        {company.companyName || "N/A"}
                      </td>
                      <td className="px-4 py-2 border-b">
                        {company.headquarter || "N/A"}
                      </td>
                      <td className="px-4 py-2 border-b">
                        <button
                          className="bg-blue-500 text-white px-2 py-1 rounded mr-2"
                          onClick={() => handleView(company._id)}
                        >
                          View
                        </button>
                        <button
                          className="bg-yellow-500 text-white px-2 py-1 rounded mr-2"
                          onClick={() => handleEditClick(company._id)}
                        >
                          Update
                        </button>
                        <button
                          className="bg-red-500 text-white px-2 py-1 rounded"
                          onClick={() => handleDeleteClick(company._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className="flex justify-center mt-6 space-x-1">
              <button
                className="flex items-center px-2 py-1 bg-white border rounded"
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <MdKeyboardArrowLeft className="mr-2" />
                Back
              </button>
              {[...Array(endPage - startPage + 1)].map((_, index) => (
                <button
                  key={index}
                  onClick={() => paginate(startPage + index)}
                  className={`px-3 py-1 mx-1 rounded ${
                    currentPage === startPage + index
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200"
                  }`}
                >
                  {startPage + index}
                </button>
              ))}
              <button
                className="flex justify-between items-center px-3 py-1 bg-white border rounded"
                onClick={() => paginate(currentPage + 1)}
                disabled={
                  currentPage ===
                  Math.ceil(filteredCompanies.length / companiesPerPage)
                }
              >
                <span>Next</span>
                <MdKeyboardArrowRight className="ml-2" />
              </button>
            </div>
          </div>
        )}
        {/* Modal for viewing company details */}
        {isModalOpen && selectedCompany && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
            <div
              className="bg-white rounded-lg shadow-lg p-6 w-3/4 "
              style={{ width: "60%" }}
            >
              <h2 className="text-2xl font-bold mb-4">
                {selectedCompany.companyName}
              </h2>
              <p>
                <strong>Headquarter:</strong> {selectedCompany.headquarter}
              </p>
              <p>
                <strong>Overview:</strong> {selectedCompany.overview}
              </p>
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href={`https://${selectedCompany.website}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500"
                >
                  {selectedCompany.website}
                </a>
              </p>
              <p>
                <strong>Contact No:</strong> {selectedCompany.contactNo}
              </p>
              <p>
                <strong>Establishment Year:</strong>{" "}
                {selectedCompany.establishmentYear}
              </p>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
      {/* Delete confirmation modal */}
      {deleteConfirmation && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50 right-[-250px]">
          <div className="bg-white p-6 rounded shadow-md w-full max-w-sm">
            <h3 className="text-lg font-bold mb-4 text-gray-800">
              Are you sure you want to delete this company?
            </h3>
            <div className="flex justify-end gap-2">
              <button
                onClick={handleCancelDelete}
                className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none"
                disabled={loading}
              >
                {loading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Edit Company Modal */}
      {isEditModalOpen && (
        <div className="fixed  inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-2/4">
            <h2 className="text-2xl font-bold mb-4">Edit Company</h2>
            <form onSubmit={handleUpdateSubmit}>
              <div className="grid grid-cols-2 gap-4">
                <label htmlFor="companyName">Company Name</label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName || ""}
                  onChange={handleFormChange}
                  placeholder="Company Name"
                  className="border rounded px-3 py-2"
                />
                <label htmlFor="marketRelevance">Market Relevance</label>

                <input
                  type="text"
                  name="marketRelevance"
                  value={formData.marketRelevance || ""}
                  onChange={handleFormChange}
                  placeholder="Market Relevance"
                  className="border rounded px-3 py-2"
                />
                <label htmlFor="headquarter">Headquarter</label>

                <input
                  type="text"
                  name="headquarter"
                  value={formData.headquarter || ""}
                  onChange={handleFormChange}
                  placeholder="Headquarter"
                  className="border rounded px-3 py-2"
                />
                <label htmlFor="establishmentYear">Establishment Year</label>

                <input
                  type="number"
                  name="establishmentYear"
                  value={formData.establishmentYear || ""}
                  onChange={handleFormChange}
                  placeholder="Establishment Year"
                  className="border rounded px-3 py-2"
                />
                <label htmlFor="companyType">Company Type</label>

                <input
                  type="text"
                  name="companyType"
                  value={formData.companyType || ""}
                  onChange={handleFormChange}
                  placeholder="Company Type"
                  className="border rounded px-3 py-2"
                />
                <label htmlFor="employeeSize">Employee Size</label>

                <input
                  type="text"
                  name="employeeSize"
                  value={formData.employeeSize || ""}
                  onChange={handleFormChange}
                  placeholder="Employee Size"
                  className="border rounded px-3 py-2"
                />
                <label htmlFor="contactNo">Contact Number</label>

                <input
                  type="text"
                  name="contactNo"
                  value={formData.contactNo || ""}
                  onChange={handleFormChange}
                  placeholder="Contact Number"
                  className="border rounded px-3 py-2"
                />
                <label htmlFor="website">Website</label>

                <input
                  type="text"
                  name="website"
                  value={formData.website || ""}
                  onChange={handleFormChange}
                  placeholder="Website"
                  className="border rounded px-3 py-2"
                />
              </div>
              <div className="flex justify-end gap-4 mt-4">
                <button
                  type="button"
                  onClick={closeEditModal}
                  className="bg-gray-500 text-white px-4 py-2 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-4 py-2 rounded"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {deleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full text-center ">
            <div className="flex justify-end">
              <div
                onClick={() => setDeleteModal(false)}
                className=" text-white rounded-lg cursor-pointer"
              >
                <button className="mt-4 py-2 px-4 bg-black text-white rounded-lg hover:bg-gray-800">
                  close
                </button>
              </div>
            </div>
            <div className="flex justify-center space-x-4">
              if you Press On Delete Button all Companies will be deleted
            </div>
            <div className="flex justify-center space-x-4">
              <button
                onClick={handleDeleteAll}
                className="bg-red-500 text-white px-2 py-1 rounded"
              >
                Delete All
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CompanyList;
